import React, { useState, useEffect } from "react";
import "./ForgotPassword.css";
import { useHistory } from "react-router-dom";
import logo from "../../assets/images/fflogo.svg";
import employeeIcon from "../../assets/images/employee_icon.png";
import userService from "../../services/user.service";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Loader from '../subComponents/Loader';
import login_ellipse from "../../assets/images/login_ellipse.svg";
import login_triangle from "../../assets/images/login_triangle.svg";
import { ArrowLeft, Copyright } from "lucide-react";
import { t } from "../../locales/translate";

function GetOtp() {
  const initialValues = { email: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const submitHandle = async () => {
    const errors = validate(formValues);
    setFormErrors(errors);  
    if (Object.keys(errors).length === 0) {
      setIsLoading(true); 
      try {
        const response = await userService.generateOtp(formValues.email.trim());
        const { status, errorCode } = response?.data || {};
        if (errorCode === "EMP404") {
          toast.error("Email does not exist!");
        } 
         else if (status === true) {
          toast.success("OTP generated successfully!");
          setTimeout(() => {
            history.push("/forgotPassword/UpdatePassword", { email: formValues.email, otpGenerated: true });
          }, 1000);
        } 
             
      } catch (error) {
         toast.error("Please try again later.");
      } finally {
        setIsLoading(false);
      }
    }
  };
  // useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     if (Object.keys(formErrors).length === 0 && isSubmit) {
    //       const response = await userService.generateOtp(formValues.email.trim());
    //       if (response.data.status === true) {
    //         toast.success("OTP generated successfully!");
    //         setTimeout(()=> {
    //           history.push("/forgotPassword/UpdatePassword", { email: formValues.email, otpGenerated: true });
    //         }, 1000)
            
    //       } else {
    //         toast.error("Email does not exist!");
    //       }
    //     }
    //   } catch (error) {
    //     console.error("Error generating OTP:", error);
    //     toast.error("An error occurred while generating OTP! Enter Valid Email");
    //   }
    //   finally {
    //     setIsLoading(false);
    //   }
    // };
    
  // }, [isSubmit]);

  const hanleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
      // Validate and clear errors on change
      if (name === "email") {
        // const errors = validate({ ...formValues, [name]: value });
        setFormErrors("");
      }
  };

  const validate = (values) => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!emailRegex.test(values.email.trim())) {
      errors.email = "Invalid email!";
    }
    return errors;
  };
   

    const currentYear = new Date().getFullYear();

  return (
  
       <>
      <ToastContainer />
      <div className="otp-page">
        <div className="otp-left">
          <img src={login_triangle} alt="Triangle" className="otp-triangle" />
          <img src={login_ellipse} alt="Ellipse" className="otp-ellipse" />
          <div className="otp-left-text">
            <h1 className="otp-heading">{t("tagline")}</h1>
            <p className="otp-subtext">{t("subtext")}</p>
          </div>
          <div className="otp-powered">
            <p>
              Powered by <u><i>Big Entities</i></u>
            </p>
          </div>
        </div>

        <div className="otp-right">
          <div className="otp-logo">
            <img src={logo} alt="Logo" />
          </div>

          <div className="otp-form-wrapper">
            <div className="otp-form">
              <div>
                <h2 className="otp-form-title">{t("forgotPassword")}</h2>
                <p className="otp-form-subtext">{t("forgotPasswordTip")}</p>
              </div>

              <div className="otp-field">
                <label htmlFor="email" className="otp-label">
                   {t("emailLabel")}
                </label>
                <input
                  name="email"
                  id="email"
                  type="text"
                  value={formValues.email}
                  onChange={hanleChange}
                  className="otp-input"
                  placeholder={ t("emailPlaceholder") }
                />
                {formErrors.email && <p className="otp-error">{formErrors.email}</p>}
              </div>

              <button
                type="button"
                onClick={submitHandle}
                className="otp-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="otp-loader"><Loader /></div>
                ) : (
                  `${t("getOTP")}`
                )}
              </button>

              <div className="otp-return-button">
              <a href="/" className="otp-return-link">
                <span className="otp-return-icon"><ArrowLeft size={16} /></span>
                {t("returnToLogin")}
              </a>
            </div>
            </div>

            {/* <span className="otp-need-help-text">Need Help?</span> */}
          <span className="otp-copyright-text" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Copyright height={16} width={16} />
            {t("copyrightText")} {currentYear}
          </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default GetOtp;
